import { render } from "./division-single.vue?vue&type=template&id=e37393e6&scoped=true"
import script from "./division-single.vue?vue&type=script&lang=js"
export * from "./division-single.vue?vue&type=script&lang=js"

import "./division-single.vue?vue&type=style&index=0&id=e37393e6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Justin\\OneDrive\\OMNIA\\Clients\\R3\\Repos\\R3_vue_web_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e37393e6"]])

export default __exports__